import { getDoQuerySpellcheckGivenRecordOfQueryParams, getFilterKeysGivenRecordOfQueryParams, getPageNumberGivenRecordOfQueryParams, getSearchQueryGivenRecordOfQueryParams, parseSearch } from "@faire/retailer-shared/search/searchRequest";
import { getSearchPageLoadKey } from "@faire/retailer-visitor-shared/nextjs-rsc-util/getSearchPageLoadKey";
import { shouldShowRscLoggedInSearchPage } from "@faire/retailer-visitor-shared/views/search-v2/util/shouldShowRscLoggedInSearchPage";
import { shouldShowRscLoggedOutSearchPage } from "@faire/retailer-visitor-shared/views/search-v2/util/shouldShowRscLoggedOutSearchPage";
import { isSearchPageRoute } from "@faire/retailer-visitor-shared/nextjs-rsc-util/isSearchPageRoute";
import { matchDiscoverPageRoute } from "@faire/retailer-visitor-shared/nextjs-rsc-util/matchDiscoverPageRoute";
// Only request RSC payload on filter, search term, page number, and spellcheck change to URL on search and discover pages
export var getShouldRequestRSCOnSearchPage = function(options) {
    var prevPathname = options.prevPathname, prevSearch = options.prevSearch, pathname = options.pathname, search = options.search;
    var prevSearchPageLoadKey = buildSearchPageLoadKey(prevPathname, prevSearch);
    var pageSearchLoadKey = buildSearchPageLoadKey(pathname, search);
    return (shouldShowRscLoggedOutSearchPage() || shouldShowRscLoggedInSearchPage()) && (isSearchPageRoute(pathname, search) !== null || matchDiscoverPageRoute(pathname, search) !== null) && pageSearchLoadKey !== prevSearchPageLoadKey;
};
var buildSearchPageLoadKey = function(pathname, search) {
    var _matchDiscoverPageRoute;
    var discoverSearchTerm = (_matchDiscoverPageRoute = matchDiscoverPageRoute(pathname, search)) === null || _matchDiscoverPageRoute === void 0 ? void 0 : _matchDiscoverPageRoute.params.searchTerm;
    var parsedSearch = parseSearch({
        search: search,
        discoverSearchTerm: discoverSearchTerm
    });
    var query = getSearchQueryGivenRecordOfQueryParams(parsedSearch);
    var filters = getFilterKeysGivenRecordOfQueryParams(parsedSearch);
    var pageNumber = getPageNumberGivenRecordOfQueryParams(parsedSearch);
    var doQuerySpellCheck = getDoQuerySpellcheckGivenRecordOfQueryParams(parsedSearch);
    return getSearchPageLoadKey({
        query: query,
        filters: filters,
        pageNumber: pageNumber,
        doQuerySpellCheck: doQuerySpellCheck
    });
};
